


















import { Component, Prop, Vue } from 'vue-property-decorator'
const valuePosition = ['top', 'left', 'right', 'bottom', 'none']
@Component
export default class BuilderDeviceHighlight extends Vue {
  @Prop({ default: 0, type: [String, Number] }) width!: string
  @Prop({
    default: 'right',
    type: [String],
    validator(value: string): boolean {
      return valuePosition.includes(value)
    }
  })
  position!: string

  get positionClasses(): string {
    switch (this.position) {
      case 'right':
        return `
          left-full
          inset-y-1/2
          bottom-auto
        `
      case 'top':
        return `
          transform
          origin-top-left
          -translate-x-0.5
          -translate-y-1
          -rotate-90
          top-0
        `
      case 'bottom':
        return `
          transform
          origin-top-left
          translate-x-0.5
          translate-y-1
          rotate-90
          bottom-0
        `
      case 'none':
        return 'invisible'
      default:
        return ''
    }
  }
}
